module.exports = __webpack_public_path__ + "static/media/7_Command-Strip.08d102fa.svg";